import { render } from "./OneOnOneLayout.vue?vue&type=template&id=2e12b550&scoped=true"
import script from "./OneOnOneLayout.vue?vue&type=script&lang=js"
export * from "./OneOnOneLayout.vue?vue&type=script&lang=js"

import "./OneOnOneLayout.vue?vue&type=style&index=0&id=2e12b550&lang=scss"
import "./OneOnOneLayout.vue?vue&type=style&index=1&id=2e12b550&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2e12b550"

export default script